import React from 'react';
import OnboardingIndex from './OnboardingIndex';

const OnboardingFreemium = () => {
  return <OnboardingIndex isFreemium />;
};

export default OnboardingFreemium;
